import httpClient from "../httpClient"
import CODE_VALUE_END_POINT from "./CODE_VALUE_END_POINT"

type LabelValue = { label: string; value: string }

const codeValueApi = {
  async getPrefecture() {
    const key = "TDFKC"

    return httpClient.get(CODE_VALUE_END_POINT.CODE, {
      queryParams: { key1s: key },
      transform: (data): LabelValue[] => data[key],
    })
  },
  async getAdMedia() {
    return httpClient.get<LabelValue[]>(CODE_VALUE_END_POINT.AD_MEDIA)
  },
  async getServiceToUse() {
    const key = "SRVTOUSE"

    return httpClient.get(CODE_VALUE_END_POINT.CODE, {
      queryParams: { key1s: key },
      transform: (data): LabelValue[] => data[key],
    })
  },
} as const

export default codeValueApi
